/**
 * Shop by Sound — editorial mobile swiper
 */
(function () {
  'use strict';

  function bindMobileSwiper(rootSelector, swiperSelector, paginationSelector, spaceBetween) {
    if (typeof window.Swiper === 'undefined') return;

    document.querySelectorAll(rootSelector).forEach((section) => {
      const el = section.querySelector(swiperSelector);
      const pagination = section.querySelector(paginationSelector);
      if (!el || el.dataset.sbsBound === '1') return;
      el.dataset.sbsBound = '1';

      const mq = window.matchMedia('(max-width: 999px)');
      let swiper = null;

      const sync = () => {
        if (mq.matches) {
          if (swiper) return;
          swiper = new window.Swiper(el, {
            slidesPerView: 1,
            spaceBetween: spaceBetween,
            watchOverflow: true,
            pagination: pagination
              ? {
                  el: pagination,
                  clickable: true,
                }
              : undefined,
          });
        } else if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      };

      sync();

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', sync);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(sync);
      }
    });
  }

  function bindEditorialSwiper() {
    bindMobileSwiper(
      '[data-sbs-editorial]',
      '[data-sbs-editorial-swiper]',
      '[data-sbs-editorial-pagination]',
      16
    );
  }

  function boot() {
    bindEditorialSwiper();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
